import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgApproveReport = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 172,
	height: 167,
	viewBox: "0 0 172 167",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_ddii_10621_65291)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 90,
				cy: 86.9375,
				r: 68,
				fill: "#F7F8FA"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter1_d_10621_65291)",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 63.8716,
				y: 54.7275,
				width: 52.2571,
				height: 64.4191,
				rx: 12,
				fill: "url(#paint0_linear_10621_65291)"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M104.601 70.7393H75.3989",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M104.601 76.4844H75.3989",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.1331 82.2295H75.3989",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter2_dii_10621_65291)",
			children: [/* @__PURE__ */ _jsx("ellipse", {
				cx: 110.5,
				cy: 108.938,
				rx: 16.5,
				ry: 16,
				fill: "#F7F8FA",
				shapeRendering: "crispEdges"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M110.5 127.438C120.92 127.438 129.5 119.227 129.5 108.938C129.5 98.6483 120.92 90.4375 110.5 90.4375C100.08 90.4375 91.5 98.6483 91.5 108.938C91.5 119.227 100.08 127.438 110.5 127.438Z",
				stroke: "#C9C9C9",
				strokeOpacity: .2,
				strokeWidth: 5,
				shapeRendering: "crispEdges"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117 104.938L109.48 112.23C109.079 112.619 108.437 112.603 108.054 112.196L105 108.937",
			stroke: "#EF4444",
			strokeWidth: 1.5,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_ddii_10621_65291",
				x: 0,
				y: .9375,
				width: 171.2,
				height: 165.2,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -14,
						dy: -10
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_10621_65291"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 1,
						operator: "erode",
						in: "SourceAlpha",
						result: "effect2_dropShadow_10621_65291"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 6,
						dy: 4
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_10621_65291",
						result: "effect2_dropShadow_10621_65291"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_10621_65291",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -5,
						dy: -2
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "shape",
						result: "effect3_innerShadow_10621_65291"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 7,
						dy: 7
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect3_innerShadow_10621_65291",
						result: "effect4_innerShadow_10621_65291"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_d_10621_65291",
				x: 59.8716,
				y: 51.7275,
				width: 64.2571,
				height: 76.4189,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 2,
						dy: 3
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_10621_65291"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_10621_65291",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_dii_10621_65291",
				x: 84.8,
				y: 84.7375,
				width: 57.4,
				height: 56.4,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 1,
						operator: "erode",
						in: "SourceAlpha",
						result: "effect1_dropShadow_10621_65291"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 3,
						dy: 4
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_10621_65291"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_10621_65291",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -2,
						dy: -2
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "shape",
						result: "effect2_innerShadow_10621_65291"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 2,
						dy: 2
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_innerShadow_10621_65291",
						result: "effect3_innerShadow_10621_65291"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_10621_65291",
				x1: 67.5296,
				y1: 50.4588,
				x2: 128.909,
				y2: 120.405,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF8C8C" }), /* @__PURE__ */ _jsx("stop", {
					offset: .562838,
					stopColor: "#EB3636"
				})]
			})
		] })
	]
});
export default SvgApproveReport;
